import type { FileCategory, FileData } from "@qendo/profile/files";
import { useState } from "react";
import { ActivityIndicator, Image, type LayoutChangeEvent, View } from "react-native";

import { FullPageModal } from "~/components/layout/modal/FullPageModal";
import { Flex, Items, Width } from "~/constants/layout";
import { useApi } from "~/providers/ApiProvider";

export type ImageBoxProps = {
    image: FileData<FileCategory.image>;
    onRequestClose: () => void;
};

export const ImageBox = ({ image, onRequestClose }: ImageBoxProps) => {
    const { img } = useApi();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [ready, setReady] = useState(false);

    const onLayout = ({
        nativeEvent: {
            layout: { width, height },
        },
    }: LayoutChangeEvent) => {
        setDimensions({ width, height });
        ready || setReady(true);
    };

    return (
        <FullPageModal onRequestClose={onRequestClose} title={image.name} scrollable={false} withDone>
            <View style={[Width.full, Flex.center, Items.center, Flex.flex]} onLayout={onLayout}>
                {ready ? (
                    <Image
                        source={img(image.url)}
                        width={dimensions.width}
                        height={dimensions.height}
                        style={{ ...dimensions, resizeMode: "contain", objectFit: "contain" }}
                    />
                ) : (
                    <ActivityIndicator />
                )}
            </View>
        </FullPageModal>
    );
};
